<template>
  <div>
    <DxBox :height="50" direction="row" width="100%">
      <DxItem :ratio="5">
        <div style="font-size: 22px">Volume History Daily</div>
      </DxItem>
    </DxBox>
  </div>
  <div v-if="volViewDetail">
    <DxChart class="chartGroup" :data-source="containerVolumeHistoryDetail">
      <DxCommonSeriesSettings argument-field="historyDate" value-field="propValue" type="line" show-in-legend="false"
        color="#9090FF" />
      <DxSize :height="400" />
      <DxLegend vertical-alignment="bottom" horizontal-alignment="center" item-text-position="bottom" visible="true" />
      <DxSeriesTemplate name-field="containerName" visible="false" />
      <DxExport :enabled="true" />
      <!-- <DxTitle text="Volume History Hourly" /> -->
      <DxTooltip :enabled="true" :customize-tooltip="customizeTooltip" zIndex="10000" />
      <DxValueAxis show-zero="true" />
    </DxChart>
  </div>
  <div v-else>
    <div id="graphVolExportBtn">
      <DxChart class="chartGroup" :data-source="containerVolumeHistory">
        <DxCommonSeriesSettings argument-field="historyDate" value-field="propValue" type="line" show-in-legend="false"
          color="#9090FF" />
        <DxSize :height="400" />
        <DxLegend vertical-alignment="bottom" horizontal-alignment="center" item-text-position="bottom"
          visible="true" />
        <DxSeriesTemplate name-field="containerName" visible="false" />
        <!-- <DxExport :enabled="true" /> -->
        <!-- <DxTitle text="Volume History Daily" /> -->
        <DxTooltip :enabled="true" :customize-tooltip="customizeTooltip" zIndex="10000" />
        <DxValueAxis show-zero="true" />
      </DxChart>
    </div>
  </div>
</template>

<script>
import {
  DxChart,
  DxSize,
  DxCommonSeriesSettings,
  DxSeriesTemplate,
  DxExport,
  DxLegend,
  // DxTitle,
  DxTooltip,
  DxValueAxis,
  // DxSeries,
  // DxZoomAndPan,
  // DxStrip,
} from "devextreme-vue/chart";
import { DxBox, DxItem } from "devextreme-vue/box";

export default {
  components: {
    DxChart,
    DxSize,
    DxCommonSeriesSettings,
    DxSeriesTemplate,
    DxLegend,
    // DxTitle,
    // DxSubtitle,
    DxTooltip,
    DxValueAxis,
    // DxSeries,
    DxExport,
    // DxStrip,
    DxBox,
    DxItem,
  },
  props: ["containerId", "container", "rangeDays", "volViewDetail"],

  created() {
    this.loadHistory();
  },
  data() {
    return {};
  },
  computed: {
    volumeUnit() {
      return this.$store.getters["properties/getVolumeUnit"];
    },
    containerVolumeHistory() {
      const currentHistoryType = this.rangeDays;
      var data = this.$store.getters["containers/getContainerHistory"];
      const volumeId =
        this.$store.getters["properties/getPropertyIdByName"]("Volume (L)");

      const volumeHist = [];
      var dateCriteria = new Date();
      dateCriteria.setDate(dateCriteria.getDate() - currentHistoryType);

      for (const key in data) {
        
        if (
          data[key].propertyId === volumeId &&
          data[key].historyDate >= dateCriteria
        ) {
          
          const hist = {
            historyId: data[key].historyId,
            customerId: data[key].customerId,
            containerId: data[key].containerId,
            containerName: data[key].containerName,
            propertyId: data[key].propertyId,
            historyDate:
              data[key].historyDate.getFullYear() +
              "-" +
              ("0" + (data[key].historyDate.getMonth() + 1)).slice(-2) +
              "-" +
              ("0" + data[key].historyDate.getDate()).slice(-2),
            propValue: parseFloat(data[key].propValue),
            historyType: data[key].historyType,
            notes: data[key].notes,
            propertyName: data[key].propertyName,
          };
          volumeHist.push(hist);
        }
      }
      
      return volumeHist;
    },

    containerVolumeHistoryDetail() {
      const currentHistoryType = this.rangeDays;
      var data = this.$store.getters["containers/getContainerHistoryDetail"];
      const volumeId =
        this.$store.getters["properties/getPropertyIdByName"]("Volume (L)");

      const volumeHist = [];
      var dateCriteria = new Date();
      dateCriteria.setDate(dateCriteria.getDate() - currentHistoryType);

      for (const key in data) {
        if (
          data[key].propertyId === volumeId &&
          data[key].historyDate >= dateCriteria
        ) {
          const hist = {
            historyId: data[key].historyId,
            customerId: data[key].customerId,
            containerId: data[key].containerId,
            containerName: data[key].containerName,
            propertyId: data[key].propertyId,
            historyDate: data[key].historyDate,
            // historyDate: data[key].historyDate.getFullYear() + "-" + ("0"+(data[key].historyDate.getMonth()+1)).slice(-2) + "-" + ("0" + data[key].historyDate.getDate()).slice(-2) + " " + data[key].historyDate.getDate().slice(-8),
            propValue: parseFloat(data[key].propValue),
            historyType: data[key].historyType,
            notes: data[key].notes,
            propertyName: data[key].propertyName,
          };
          volumeHist.push(hist);
        }
      }
      return volumeHist;
    },
    volViewLbl() {
      return this.volViewDetail ? "Detail" : "Summary";
    },
  },
  // watch: {
  //   containerId: function (newId, oldId) {
  //     this.loadHistory();
  //   }
  // },
  methods: {
    async loadHistory() {
      // if (this.container.containerId != null && this.container.containerId !== undefined && this.container.containerId > 0)
      // {
      //   await this.$store.dispatch("containers/loadContainerHistory", this.container.containerId);
      //   await this.$store.dispatch("containers/loadContainerHistoryDetail", this.container.containerId);
      // }
    },
    customizeTooltip(pointInfo) {
      // console.log("POINT",pointInfo)
      // console.log("cm",(this.$store.getters["containers/getContainerHistory"]).filter(x=>x.propertyName=='Volume (cm)' && x.historyDate==pointInfo.argumentText))
      return {
        html: `
          <div>
            <div style="width: 100px;padding:5px;text-align: center;"><span style="font-size:18px;font-weight:bold;">${pointInfo.value} ${this.volumeUnit}</span></div>
            <div style="width: 100px;padding:5px;text-align: center;">${pointInfo.argumentText}</div>
          </div>`,
      };
    },
  },
};
</script>

<style scoped>
.divGroup {
  width: 90%;
  border-style: solid;
  border-width: 1px;
  margin: 20px;
  border-color: rgb(100, 100, 100);
  border-radius: 6px;
  padding: 20px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.propHeader {
  font-size: 16px;
  font-weight: 300;
  color: rgb(255, 255, 255, 0.4);
  margin-bottom: 6px;
  z-index: 20;
}

.propVal {
  font-size: 18px;
  font-weight: 300;
  margin-left: 10px;
  margin-bottom: 10px;
  z-index: 20;
}

.propThreshold {
  font-size: 12px;
  font-weight: 300;
  color: rgb(255, 255, 255, 0.3);
  margin-left: 10px;
  margin-bottom: 2px;
  z-index: 20;
}

.hr {
  height: 1px;
  border: 1px solid #444;
}

.chartGroup {
  /* width: 85%; */
  height: 300px;
}
</style>
